const DescriptionSolviPremium = () => {
    return(

         <div className="bg-white rounded-md shadow-lg p-4 max-w-md w-full mx-auto mb-10">
            <p className="text-left text-md">
              This is an auto-renewing subscription. Your first payment includes
              a 50% introductory discount.
              <br />
              After that, your Solvi Premium plan will automatically renew at
              the regular full price based on the billing option you selected
              (monthly, every 3 months, or yearly) until you cancel. You’ll
              receive an email receipt from Stripe for each payment. In some
              cases, that email may also include a secure link to manage or
              cancel your subscription.
              <br /> You can cancel anytime by contacting our support team at{" "}
              <a
                href="mailto:support@solvi.club"
                className="text-pink-600 underline"
              >
                support@solvi.club
              </a>
              . This subscription is subject to Solvi’s{" "}
              <a
                href="/privacy-policy"
                className="text-pink-600 underline hover:text-pink-700"
              >
                Privacy Policy
              </a>
              ,{" "}
              <a
                href="/terms-of-use"
                className="text-pink-600 underline hover:text-pink-700"
              >
                Terms of Use
              </a>
              , and{" "}
              <a
                href="/refund-policy"
                className="text-pink-600 underline hover:text-pink-700"
              >
                Refund Policy
              </a>
              .
            </p>
          </div>
    )
}


export default DescriptionSolviPremium;